import { TwoCategoryPie } from '@lightwaverf/simple-d3-graph';
import { LwGeneralGraph } from './general-graph';

export class LwEco7Graph extends LwGeneralGraph {
    graph: TwoCategoryPie;
    constructor(element) {
        super(element);
    }

    draw(data: any[]) {

        this.graph = new TwoCategoryPie(this.element);

        this.graph.draw(data, {fieldX: 'hour_of_day', fieldY: 'value'}, {chartArea: {height: 220}});
    }
}
